import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

// ── Mobile root path guard: force redirect to home if path is empty/invalid ──
// This runs once on initial load only; no Supabase or cart logic is touched.
if (typeof window !== 'undefined' && !window.__HOME_REDIRECT_CHECKED__) {
  (window as any).__HOME_REDIRECT_CHECKED__ = true
  const rawPath = window.location.pathname
  const isInvalidPath = !rawPath || rawPath === '' || rawPath === 'undefined' || rawPath === 'null' || rawPath.length === 0
  if (isInvalidPath) {
    window.location.replace('/')
  }
}

// ── Global unhandled rejection guard: suppress stray Supabase refresh-token errors ──
if (typeof window !== 'undefined') {
  window.addEventListener('unhandledrejection', (event) => {
    const reason = event.reason
    if (
      reason &&
      typeof reason === 'object' &&
      typeof (reason as Error).message === 'string' &&
      ((reason as Error).message.includes('Invalid Refresh Token') ||
        (reason as Error).message.includes('Refresh Token Not Found'))
    ) {
      console.warn('[Global Guard] Suppressed Invalid Refresh Token error. User will be redirected to login.')
      // Clear local auth caches so the app treats the user as logged out
      localStorage.removeItem('jishi_auth_user')
      localStorage.removeItem('jishi_auth_token')
      localStorage.removeItem('jishi_user')
      event.preventDefault()
    }
  })
}

// Initialize mock data migration flag
if (!localStorage.getItem('supabase_migration_done')) {
  localStorage.setItem('supabase_migration_done', 'false')
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)